import { template } from "@ember/template-compiler";
import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { dropTask, timeout } from 'ember-concurrency';
import WrButton from 'ember-wiser/components/wr/button';
import type JournalEventModel from 'parog-web/models/journal-event';
import type { Signature as LinkButtonSignature } from 'ui-kit/components/link-button';
import LinkButton from 'ui-kit/components/link-button';
import emberSwal from 'ui-kit/utils/ember-swal';
export interface ArchiveJournalEventButtonSignature {
    Element: LinkButtonSignature['Element'];
    Args: {
        iconSize?: string;
        /** Opt-in the new Wiser design system if the component cannot be migrated immediately */ wiser?: boolean;
        afterArchived?: () => void;
        confirmationTitle?: string;
        additionalInformation?: string;
        journalEvent: JournalEventModel;
    };
    Blocks: {
        default: [];
    };
}
export default class ArchiveJournalEventButton extends Component<ArchiveJournalEventButtonSignature> {
    deleteJournalEventTask = dropTask(async (je1: JournalEventModel)=>{
        // This is just to help understand what's going on.
        await timeout(200);
        await je1.archive();
        this.args.afterArchived?.();
    });
    @action
    async confirmArchive(event1) {
        event1.stopPropagation();
        if (this.deleteJournalEventTask.isRunning) return;
        const result1 = await emberSwal.fire({
            title: this.args.confirmationTitle || 'Confirmer la suppression',
            text: this.args.additionalInformation || 'Cette opération ne peut pas être annulée.',
            icon: 'warning',
            cancelButtonText: 'Annuler',
            showCancelButton: true,
            confirmButtonText: 'Oui, supprimer'
        });
        if (result1.value) {
            this.deleteJournalEventTask.perform(this.args.journalEvent);
        }
    }
    static{
        template(`
    {{#if @wiser}}
      <WrButton
        @icon='Trash'
        @variant='outlined-mini'
        {{on 'click' this.confirmArchive}}
        ...attributes
      />
    {{else}}
      <LinkButton
        data-tooltip={{unless (has-block) 'Supprimer'}}
        aria-label='archiver le JE'
        {{on 'click' this.confirmArchive}}
        ...attributes
      >
        {{#if this.deleteJournalEventTask.isRunning}}
          <i class={{concat 'notched circle loading icon' @iconSize}}></i>
        {{else}}
          <i class={{concat 'trash alternate icon outline' @iconSize}}></i>
        {{/if}}
        {{yield}}
      </LinkButton>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
